import { render, staticRenderFns } from "./proType-child-add.vue?vue&type=template&id=59ad6e86&scoped=true&"
import script from "./proType-child-add.vue?vue&type=script&lang=js&"
export * from "./proType-child-add.vue?vue&type=script&lang=js&"
import style0 from "./proType-child-add.vue?vue&type=style&index=0&id=59ad6e86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ad6e86",
  null
  
)

export default component.exports